'use client'

import dynamic from 'next/dynamic'
import { FC } from 'react'

const MarkdownView = dynamic(() => import('@/components/ui/markdown-view/markdown-view').then((mod) => mod.MarkdownView), { ssr: false })

export interface VideoTextSectionProps {
  content: string
}

const VideoTextSection: FC<VideoTextSectionProps> = ({ content }) => {
  return (
    <div className="info-section info-text-section">
      <MarkdownView content={content} />
    </div>
  )
}

export default VideoTextSection
